import { Checkbox } from 'antd';
import { CountdownTimer } from 'components/UI/CountdownTimer';
import OutlineTag from 'components/UI/Responsive/OutlineTag';
import { ShimmerLine } from 'components/UI/Responsive/Shimmer';
import { OrderIntentionStatusEnum } from 'enums/orderIntentionStatus.enum';
import { OrderIntention } from 'model/OrderIntention';
import moment from 'moment';
import { formatMoney } from 'screens/MyOrders/Detail/buildMyOrderDetailGroups';
import {
  describeOrderReference,
  describeProduct,
  orderTotal,
  unitTotal,
} from '../Detail/buildOrderIntentionDetailGroups';
import { renderStatusIcon } from './statusIcon';

import * as S from './styles';

interface Props {
  order: OrderIntention;
  branch?: string;
  showsCustomer: boolean;
  isSelectable: boolean;
  isSelected: boolean;
  isSelectionDisabled: boolean;
  onSelect: () => void;
  onClick: () => void;
}

export default function OrderIntentionCard({
  order,
  branch,
  showsCustomer,
  isSelectable,
  isSelected,
  isSelectionDisabled,
  onSelect,
  onClick,
}: Props) {
  const reference = describeOrderReference(order);

  return (
    <S.Card data-selected={isSelected}>
      {isSelectable && (
        <S.Select>
          <Checkbox
            aria-label={`Selecionar ${reference} · ${order.productDescription}`}
            checked={isSelected}
            disabled={isSelectionDisabled}
            onChange={onSelect}
          />
        </S.Select>
      )}
      <S.Body type="button" onClick={onClick}>
        <S.Header>
          <S.Heading>
            <S.Title>{describeProduct(order)}</S.Title>
            <S.Code>
              {order.productCode} · {reference}
              {showsCustomer && ` · Chave ${order.customerCode}`}
            </S.Code>
          </S.Heading>
          <S.Status>
            <S.StatusIcon aria-hidden>
              {renderStatusIcon(order.status)}
            </S.StatusIcon>
            {order.statusDescription}
          </S.Status>
        </S.Header>
        <S.Source>
          <S.Parties>
            {order.siteCode
              ? `${order.siteCode} - ${order.siteName}`
              : order.siteName}{' '}
            · {order.qualityCode} · {order.packingDescription}
          </S.Parties>
          <OutlineTag>{order.origin}</OutlineTag>
        </S.Source>
        <S.Quantity>
          {order.quantityPacking} x {order.quantityUnit} ·{' '}
          {formatMoney(unitTotal(order))}
          {order.status === OrderIntentionStatusEnum.PENDENTE && (
            <S.Countdown>
              <CountdownTimer
                expirationTime={moment(order.expirationTime)}
                onExpire={() => undefined}
              />
            </S.Countdown>
          )}
        </S.Quantity>
        <S.Total>{formatMoney(orderTotal(order, branch))}</S.Total>
      </S.Body>
    </S.Card>
  );
}

export function OrderIntentionCardSkeleton() {
  return (
    <S.Card aria-hidden>
      <S.Placeholder>
        <S.PlaceholderHeader>
          <S.PlaceholderHeading>
            <ShimmerLine $width="75%" $height="16px" />
            <ShimmerLine $width="45%" />
          </S.PlaceholderHeading>
          <ShimmerLine $width="72px" $height="16px" />
        </S.PlaceholderHeader>
        <ShimmerLine $width="85%" />
        <S.PlaceholderFooter>
          <ShimmerLine $width="40%" />
          <ShimmerLine $width="64px" $height="16px" />
        </S.PlaceholderFooter>
      </S.Placeholder>
    </S.Card>
  );
}
